import { render, staticRenderFns } from "./InvalidRoute.vue?vue&type=template&id=8dea777e&scoped=true"
import script from "./InvalidRoute.vue?vue&type=script&lang=js"
export * from "./InvalidRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dea777e",
  null
  
)

export default component.exports